import { render } from "./NeurologicalDiseaseTreatmentPatternInterventions.vue?vue&type=template&id=0a154ded&scoped=true"
import script from "./NeurologicalDiseaseTreatmentPatternInterventions.vue?vue&type=script&lang=js"
export * from "./NeurologicalDiseaseTreatmentPatternInterventions.vue?vue&type=script&lang=js"

import "./NeurologicalDiseaseTreatmentPatternInterventions.vue?vue&type=style&index=0&id=0a154ded&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a154ded"]])

export default __exports__